import { useSelector } from 'react-redux'

export default function useHasPermission(permission) {
    const permissions = useSelector(state => state.user.permissions)
    if (!permission) return false

    return permissions.some(x => x.name === permission && x.provider_name === 'PermissionProvider.PARTNER' && x.is_enabled) &&
        !permissions.some(x => x.name === permission && x.provider_name === 'PermissionProvider.USER' && !x.is_enabled)
}
